<template>
  <button type="button" class="modal-close" title="Закрыть">
    <IconClose />
  </button>
</template>
